import OptionPage from "../components/optionPageStructure";
import ProductGrid from "../components/productGrid";
import { checkMissingSelections } from "../utils/checkMissingSelections";

const url = process.env.REACT_APP_BACKEND_CONNECTION;

export default function Furniture() {
  async function loadFurniture({ user, summaryId }) {
  const data = await fetch(`${url}/form/furniture?summary_id=${summaryId}`, {
    headers: { Authorization: `Bearer ${user.token}` }
  }).then(res => res.json());
  
  const optionsWithType = {};
  Object.entries(data.options || {}).forEach(([category, opts]) => {
    optionsWithType[category] = opts.map(opt => ({ ...opt, type: "product" }));
  });

  return {
    options: optionsWithType,
    selectedOptions: data.selected || { byCategory: {}, all: [] }
  };
}

  return (
    <OptionPage
      title="Kalusteet"
      parentCategory="Kalusteet"
      previousParentCategory="Kylpyhuoneen kalustejärjestys"
      currentStep="furniture"
      customLoader={loadFurniture}
      customRenderer={ProductGrid}
      checkMissingSelections={checkMissingSelections}
      hideTitle={true}
    />
  );
}